import api from './client';
import { User, RegisterData } from '../types/user';

export interface DriverResponse {
  success: boolean;
  data: User;
}

export interface DriversListResponse {
  success: boolean;
  data: {
    users: User[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
      hasMore: boolean;
    };
  };
}

export const driversApi = {
  /**
   * List all drivers for the current company
   */
  async listDrivers(): Promise<User[]> {
    // Add timestamp to bust cache when switching companies
    const timestamp = new Date().getTime();
    const response = await api.get<DriversListResponse>(`/api/users?role=driver&_t=${timestamp}`);
    return response.data.data.users;
  },

  /**
   * Register a new driver
   */
  async registerDriver(data: RegisterData): Promise<User> {
    const response = await api.post<DriverResponse>('/api/auth/register', {
      ...data,
      role: 'driver',
    });
    return response.data.data;
  },

  /**
   * Get driver by ID
   */
  async getDriver(id: string): Promise<User> {
    const response = await api.get<DriverResponse>(`/api/users/${id}`);
    return response.data.data;
  },

  /**
   * Update driver information
   */
  async updateDriver(id: string, data: Partial<User>): Promise<User> {
    const response = await api.patch<DriverResponse>(`/api/users/${id}`, data);
    return response.data.data;
  },
};
